import { makeContextModule } from '@cian/react-utils';

import { type FC, type JSX } from 'react';
import { Provider } from 'react-redux';

import { type IReduxStateProvider } from '@/packages/redux-state/ReduxState';

export const { Context, useContext: useReduxState } = makeContextModule<IReduxStateProvider>({
  contextName: 'ReduxStateContext',
});

type ReduxStateContextProviderProps = {
  reduxState: IReduxStateProvider;
  children: JSX.Element;
};

export const ReduxStateContextProvider: FC<ReduxStateContextProviderProps> = props => {
  const { reduxState, children } = props;

  return (
    <Provider store={reduxState.store}>
      <Context.Provider value={reduxState}>{children}</Context.Provider>
    </Provider>
  );
};
